<template>
    <form-container headerText="Spielfrei für Verein setzen" :width="550" action="addSpielfrei"
                    :valid-actions="['addSpielfrei']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-radio-group v-if="dataObject.semester!=='A'" v-model="dataObject.semester" :rules="[rules.required]"
                           row hide-details class="mb-4">
                <v-radio v-for="(type, n) in semesterTypes" :key="n"
                         :label="type.label" :value="type.value"></v-radio>
            </v-radio-group>
            <v-text-field v-model="dataObject.runde" :rules="[rules.required]"
                          label="Rundennummer" type="number">
            </v-text-field>
            <v-autocomplete class="my-3" v-model="dataObject.teamId" item-value="id" item-text="name"
                            no-data-text="keine Daten gefunden"
                            :items="mannschaften" dense label="Mannschaft" :rules="[rules.required]">
            </v-autocomplete>
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "../../services/formRules";

    export default {
        components: {FormContainer},
        name: "spiel-plan-frei",
        props: ['defaultRunde', 'saison'],
        data: () => ({
            rules: null,
            dataObject: {
                runde: null,
                semester: null,
                teamId: null
            },
            error: '',
        }),
        computed: {
            semesterTypes(){ return this.$store.state.local.semesterTypes; },
            mannschaften() { return this.saison.getSortedTeamList(); }
        },
        created(){
            this.rules = new FormRules();
            if ( this.defaultRunde ) {
                const parts = this.defaultRunde.split(' ');
                this.dataObject.semester = parts[1].split('_')[0];
                this.dataObject.runde = parts[0].split('/')[1];
            }
        },
        methods: {
            async save(){
                this.$store.state.local.loader = true;
                const key = 'spielfrei.' + this.dataObject.runde + '_' +
                            this.dataObject.semester + '.' + this.dataObject.teamId;
                this.saison.local.documentUpdates = {
                    [key]: true,
                };
                const reply = await this.saison.saveEdited('saison_edit');
                if ( reply.successful ) {
                    this.$store.state.local.loader = false;
                    window.history.back();
                } else {
                    this.$store.state.local.loader = false;
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
            }
        },
    }
</script>

<style scoped>

</style>